import { createGlobalStyle } from 'styled-components';

import finlandicaRegularWoff2 from 'fonts/finlandica-regularWeb.woff2';
import finlandicaRegularWoff from 'fonts/finlandica-regularWeb.woff';
import finlandicaRegularTtf from 'fonts/finlandica-regularWeb.ttf';
import finlandicaBoldWoff2 from 'fonts/finlandica-boldWeb.woff2';
import finlandicaBoldWoff from 'fonts/finlandica-boldWeb.woff';
import finlandicaBoldTtf from 'fonts/finlandica-boldWeb.ttf';
import interRegularWoff2 from 'fonts/inter-regular.woff2';
import interMediumWoff2 from 'fonts/inter-medium.woff2';
import interSemiboldWoff2 from 'fonts/inter-semibold.woff2';
import interBoldWoff2 from 'fonts/inter-bold.woff2';

const GlobalStyles = createGlobalStyle`
  @font-face {
    font-family: 'Finlandica';
    src: url(${finlandicaRegularWoff2}) format('woff2'),
         url(${finlandicaRegularWoff}) format('woff'),
         url(${finlandicaRegularTtf}) format('ttf');
    font-weight: normal;
    font-style: normal;
  }
  @font-face {
    font-family: 'Finlandica';
    src: url(${finlandicaBoldWoff2}) format('woff2'),
         url(${finlandicaBoldWoff}) format('woff'),
         url(${finlandicaBoldTtf}) format('ttf');
    font-weight: bold;
    font-style: normal;
  }
  @font-face {
    font-family: 'Inter';
    src: url(${interRegularWoff2}) format('woff2');
    font-weight: 400;
    font-style: normal;
    font-display: swap;
  }
  @font-face {
    font-family: 'Inter';
    src: url(${interMediumWoff2}) format('woff2');
    font-weight: 500;
    font-style: normal;
    font-display: swap;
  }
  @font-face {
    font-family: 'Inter';
    src: url(${interSemiboldWoff2}) format('woff2');
    font-weight: 600;
    font-style: normal;
    font-display: swap;
  }
  @font-face {
    font-family: 'Inter';
    src: url(${interBoldWoff2}) format('woff2');
    font-weight: 700;
    font-style: normal;
    font-display: swap;
  }
  :root {
    --color-primary: ${p => p.theme.colors.deepBlue};
    --color-primary-dark: ${p => p.theme.colors.darkBlue};
    --color-surface: ${p => p.theme.colors.surface};
    --color-surface-elevated: ${p => p.theme.colors.surfaceElevated};
    --color-border: ${p => p.theme.colors.border};
    --color-border-subtle: ${p => p.theme.colors.borderSubtle};
    --color-text: ${p => p.theme.colors.actionFg};
    --color-text-muted: ${p => p.theme.colors.midGrey};
    --color-success: ${p => p.theme.colors.success};
    --color-success-bg: ${p => p.theme.colors.successBg};
    --color-warning: ${p => p.theme.colors.warning};
    --color-warning-bg: ${p => p.theme.colors.warningBg};
    --color-danger: ${p => p.theme.colors.danger};
    --color-danger-bg: ${p => p.theme.colors.dangerBg};
    --color-info: ${p => p.theme.colors.info};
    --color-info-bg: ${p => p.theme.colors.infoBg};
    --color-focus-ring: ${p => p.theme.colors.focusRing};
  }
  * {
    box-sizing: border-box;
  }
  *:before,
  *:after {
    box-sizing: border-box;
  }
  html {
    height: 100%;
    overflow-y: scroll;
    overflow-x: hidden;
    font-size: 62.5%;
  }
  body {
    height: 100%;
    margin: 0;
    font-family: ${p => p.theme.fonts.body};
    font-size: ${p => p.theme.fontSize.base};
    color: ${p => p.theme.colors.black};
    background-color: ${p => p.theme.colors.surface};
  }
  body,
  html {
    min-height: 100%;
  }
  div#root {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
  }
  main {
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;
    position: relative;
  }
  a {
    text-decoration: none;
    color: #ffffff;
    :hover {
      text-decoration: underline
    }
  }
  h1,h2,h3,h4 {
    font-family: Finlandica;
  }
  h1 {
    font-size: ${p => p.theme.fontSize['4xl']};
  }
  h2 {
    font-size: ${p => p.theme.fontSize['3xl']};
  }
  h3 {
    font-size: ${p => p.theme.fontSize['2xl']};
  }
  h4 {
    font-size: ${p => p.theme.fontSize.xl};
  }
  h5 {
    font-size: ${p => p.theme.fontSize.base};
  }
  button {
    cursor: pointer;
  }
  :focus-visible {
    outline: 2px solid ${p => p.theme.colors.focusRing};
    outline-offset: 2px;
  }
  ul,
  ol {
    margin-top: 1rem;
    margin-bottom: 1rem;
    li {
      margin-bottom: 0.5rem;
    }
    ul,
    ol {
      margin-bottom: 0;
    }
  }
`;

export default GlobalStyles;
